<template>
	<div class="m-portlet m-portlet--brand">
		<div class="row">
			<div class="col-md-3">
		        <fieldset class="find_bet">     
		            <legend>Game</legend>
		            <div class="panel panel-default">
		                <div class="panel-body">
		                    <div class="gameFilter" id="gameFilter"></div>
		                </div>
		            </div>
		        </fieldset>
		    </div>
		    <div class="col-md-5">
		        <fieldset class="find_bet">     
		            <legend>Channel</legend>
		            <div class="panel panel-default">
		                <div class="panel-body">
		                    <div class="channelFilter" id="channelFilter"></div>
		                </div>
		            </div>
		        </fieldset>
		    </div>
		    <div class="col-md-4">
		        <fieldset class="find_bet">     
		            <legend>Props</legend>
		            <div class="panel panel-default">
		                <div class="panel-body">
		                    <div class="propFilter" id="propFilter"></div>
		                </div>
		            </div>
		        </fieldset>
		    </div>
		</div>
		<div class="row">
		    <div class="col-md-12">
		        <input class="btn btn-primary" type="button" value="Xem" id="rerenderChart" />
		    </div>
		</div>
		<div class="m-portlet__body row table-content">
			<div class="col-md-12">
		        <div id="chartContainer" style="width:100%; height:400px;"></div>
		    </div>
		    <div class="col-md-12">
		        <div class="portlet box red_custome">
		            <div class="portlet-title">
		                <div class="caption">
		                    <i class="fa fa-cogs"></i>Chi tiết user
		                </div>
		            </div>
		            <div id="portlet-body" class="portlet-body">
		                <table id="user-detail" class="table table-striped table-bordered" cellspacing="0" width="100%">
		                    <thead>
		                        <tr>
		                            <th>Ngày</th>
		                            <th>Game</th>
		                            <th>Channel</th>
		                            <th>Property</th>
		                            <th>Number</th>
		                            <th>Player</th>
		                            <th>Total point</th>
		                        </tr>
		                    </thead>
		                    <tbody id="user-detail-content"></tbody>
		                </table>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import uniq from 'lodash/uniq';
	import indexOf from 'lodash/indexOf';

	export default {
		data(){
	        return {
	        	
	        }
	    },

	    mounted(){
	    	if($("#highchart").length > 0) return;

	    	let highChartScript = document.createElement('script');
		    highChartScript.setAttribute('id', 'highchart');
		    highChartScript.setAttribute('src', 'https://code.highcharts.com/highcharts.src.js');
		    document.head.appendChild(highChartScript);
	    },

	    created(){
    		this.getHighRateData();
    	},

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	    	initScript: function(data){
	    		let vm = this;

	    		$("#rerenderChart").unbind("click");
				$("#rerenderChart").bind("click", ()=>{vm.rerenderChart(data)});

	            let games = uniq(data.map((e)=>{
	                return e.g;
	            })).sort((a,b) => { return parseInt(a) - parseInt(b) }).map(el => {
	                return {id: el, name: vm.gameInfo.games[el]};
	            });

	            let props = uniq(data.map((e)=>{
	                return e.p;
	            })).sort((a,b) => { return parseInt(a) - parseInt(b) }).map(el => {
	                return {id: el, name: vm.gameInfo.props[el]};
	            });

	            let channels = uniq(data.map((e)=>{
	                return e.c;
	            })).sort((a,b) => { return parseInt(a) - parseInt(b) }).map(el => {
	            	let channel = el.split(".").map((ex) => { ex = parseInt(ex); return vm.gameInfo.channels[ex].alias; });
	                return {id: el, name: channel.join(", ")};
	            });

	            this.buildFilter("gameFilter", games);
	            this.buildFilter("channelFilter", channels);
	            this.buildFilter("propFilter", props);

	            this.drawChart(data);
	    	},

	        getHighRateData: function(){
	        	let vm = this;

	        	window.axios.get("admin-panel/tools/high-rate-number")
	        				.then((res) => {
	        					res = res.data;
	        					vm.initScript(res.data);
	        				})
	        				.catch((error) => {

	        				});
	        },

	       	buildFilter: function(container, data){
	       		let dom = "";
		        for(let i=0;i<data.length;i++){
		            dom += "<div style='padding-right:10px; display:inline-block'><input type='checkbox' style='padding-right:3px' class='checkbox-filter' checked id='input_"+data[i].id+"' value='"+data[i].id+"' /><label for='input_"+data[i].id+"'>" + data[i].name + "</label></div>";
		        }

		        $('#'+container).html(dom);
	       	},

	       	getFilterDataWithCheckbox: function(data){
		        let gs = [];
		        let cs = [];
		        let ps = [];

		        $("#gameFilter input:checked").each((i,e) => {
		            let v = parseInt($(e).val());
		            gs.push(v);
		        });

		        $("#channelFilter input:checked").each((i,e) => {
		            let v = $(e).val();
		            cs.push(v);
		        });

		        $("#propFilter input:checked").each((i,e) => {
		            let v = parseInt($(e).val());
		            ps.push(v);
		        });

		        let filtered = data.filter(e => {
		            return indexOf(gs, e.g) >= 0 && indexOf(cs, e.c) >= 0 && indexOf(ps, e.p) >= 0;
		        });

		        return filtered;
		    },

	       	rerenderChart: function(data){
		        let filtered = this.getFilterDataWithCheckbox(data);

		        this.drawChart(filtered);
		    },

		    drawUserDetailTable: function(data){
		        let dom = "";
		        let vm = this;
		        
		        for(let i=0;i<data.length;i++){
		        	let channel = data[i].c;
			        channel = channel.split(".").map((e) => { e = parseInt(e); return vm.gameInfo.channels[e].alias; });

		            dom += "<tr>";
		            dom += "<td>"+data[i].d+"</td>";
		            dom += "<td>"+this.gameInfo.games[data[i].g]+"</td>";
		            dom += "<td>"+channel.join(", ")+"</td>";
		            dom += "<td>"+this.gameInfo.props[data[i].p]+"</td>";
		            dom += "<td>"+data[i].n+"</td>";
		            dom += "<td>"+data[i].u+"</td>";
		            dom += "<td>"+data[i].tp+"</td>";
		            dom += "</tr>"
		        }

		        $("#user-detail-content").html(dom);
		    },

		    drawChart: function(values){
		        $("#user-detail-content").html('');

		        let categories = uniq(values.map((e)=>{
		            return e.n;
		        })).sort((a,b) => { return parseInt(a) - parseInt(b) });

		        let seriesData = [];
		        for(let i=0;i<categories.length;i++){
		            let dataNumber = values.filter(e=>{ return e.n == categories[i]; });
		            let totalPoint = dataNumber.reduce(function(acc, val) { return acc + val.tp; }, 0);
		            seriesData.push(totalPoint);
		        }

		        let to = moment();
		        let from = moment().subtract(3, "days");
		        let previousPoint = null;
		        let vm = this;

		        var myChart = Highcharts.chart('chartContainer', {
		            chart: {
		                type: 'column'
		            },
		            title: {
		                text: 'Từ ngày '+from.format("DD-MM-YYYY")+' đến ngày '+to.format("DD-MM-YYYY")
		            },
		            xAxis: {
		                categories: categories
		            },
		            yAxis: {
		                title: {
		                    text: 'Total point'
		                }
		            },
		            plotOptions: {
		                series: {
		                    cursor: 'pointer',
		                    point: {
		                        events: {
		                            click: function () {

		                                if (previousPoint) {
		                                    previousPoint.update({ color: '#7cb5ec' });
		                                }

		                                previousPoint = this;
		                                this.update({ color: '#d64635' });
		                                

		                                let filtered = values.filter(e => {
		                                    return e.n == this.category;
		                                });

		                                vm.drawUserDetailTable(filtered);
		                            }
		                        }
		                    }
		                }
		            },
		            series: [{
		                name: 'Tổng điểm',
		                data: seriesData
		            }]
		        });
		    }
	    }
	}

</script>